<template>
    <div class="project-tabs">
        <div class="item" v-for="item in tabData" :key="item.name" :class="[{'active': item.key == tabKey, 'auto': item.isAuto}]" :ref="item.key" @click="tabKey = item.key">
            <div class="text">{{item.name}}</div>
            <div class="text active">{{item.name}}</div>
            <div class="line-active"></div>
        </div>
        <div class="line"></div>
        <!-- <div class="line-active" :style="lineActiveWidth"></div> -->
    </div>
</template>

<script>
export default {
    name: "sd-tabs",
    props: {
        data: {
            type: Array,
            default: () => {
                return []
            }
        },
        value: {
            type: String || Number,
            default: ""
        }
    },
    data() {
        return {
            tabKey: this.value,
            tabData: this.data
        }
    },

    watch: {
        tabKey(val) {
            this.$emit("update:value", val)
        },

        value(val) {
            this.tabKey = val
        }
    },

    computed: {
        lineActiveWidth() {
            const index = this.tabData.findIndex(item => {
                return item.key == this.tabKey
            })
            this.accountPlaceholderText = this.tabData[index].placeholder;
            return `width: ${100/this.tabData.length}%;left: ${100/this.tabData.length*index}%`
        }
    },
}
</script>

<style lang="scss" scoped>
    .project-tabs {
        height: 43px;
        line-height: 43px;
        display: flex;
        position: relative;
        overflow: hidden;

        .item {
            flex: 1;
            color: #B6B9C0;
            font-size: 18px;
            font-weight: bold;
            position: relative;

            &.active {
                color: #0B0F23;

                .line-active {
                    opacity: 1;
                }
            }
            
            .text {
                &.active {
                    font-weight: bold;
                    opacity: 0;
                }
            }

            .line-active {
                opacity: 0;
                width: 100%;
                position: absolute;
                bottom: 0;
                height: 2px;
                background: #E22F25;
            }
        }

        .line {
            position: absolute;
            width: 100%;
            bottom: 0;
            height: 2px;
            background: #B6B9C0;
        }

        // .line-active {
        //     position: absolute;
        //     bottom: 0;
        //     height: 2px;
        //     background: #E22F25;
        // }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/tabs.vue